"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpertiseLevelMetricsChart = exports.ExpertiseLevelMetricsChartDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var circle_trail_bar_chart_1 = require("../elements/circle-trail-bar-chart");
var router_1 = require("@reach/router");
var use_entities_1 = require("../../hooks/use-entities");
var entity_type_circle_bar_chart_icon_1 = require("./entity-type-circle-bar-chart-icon");
var cls = (0, cn_1.classNames)('expertise-level-metrics-chart');
exports.ExpertiseLevelMetricsChartDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ChartStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: -", ";\n    margin-right: -", ";\n  \n    padding: ", ";\n    border: 1px solid ", ";\n\n    .shp--circle-trail-bar-chart-label {\n      font-size: ", ";\n      font-weight: 500;\n      padding-right: ", ";\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    margin-left: -", ";\n    margin-right: -", ";\n  \n    padding: ", ";\n    border: 1px solid ", ";\n\n    .shp--circle-trail-bar-chart-label {\n      font-size: ", ";\n      font-weight: 500;\n      padding-right: ", ";\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-subtle'), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(5), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('primary')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: 0;\n    margin-right: 0;\n  "], ["\n    margin-left: 0;\n    margin-right: 0;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(5))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Chart: (0, styled_components_1.default)(circle_trail_bar_chart_1.CircleTrailBarChart)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ChartStyles)
};
var ExpertiseLevelMetricsChart = function (props) {
  var className = props.className,
    children = props.children,
    _a = props.items,
    items = _a === void 0 ? [] : _a;
  var entities = (0, use_entities_1.useEntities)();
  var chartItems = (0, react_1.useMemo)(function () {
    return items.map(function (expertiseLevel) {
      var onItemClick = function () {
        (0, router_1.navigate)("".concat(entities.Person.routes.list, "/expertise-levels:").concat(expertiseLevel.slug));
      };
      var icon = function (_a) {
        var size = _a.size;
        return react_1.default.createElement(entity_type_circle_bar_chart_icon_1.EntityTypeCircleBarChartIcon, {
          onClick: onItemClick,
          size: size,
          entityTypeName: "Person"
        });
      };
      return {
        label: expertiseLevel.name,
        value: expertiseLevel.peopleCount,
        size: 'default',
        onCircleClick: onItemClick,
        onLabelClick: onItemClick,
        circleComponent: icon
      };
    });
  }, [items]);
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Chart, {
    showTicks: false,
    showMarks: false,
    animate: true,
    showCountupValues: false,
    minorDivisions: 4,
    majorDivisions: 6,
    lowerValue: -25,
    startOpacity: 0,
    heightSizeMultipliers: {
      small: 2,
      default: 1.5,
      large: 4
    },
    backgroundColor: "#FAFAFA",
    items: chartItems
  }));
};
exports.ExpertiseLevelMetricsChart = ExpertiseLevelMetricsChart;
exports.ExpertiseLevelMetricsChart.cls = cls;
exports.ExpertiseLevelMetricsChart.defaultProps = exports.ExpertiseLevelMetricsChartDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;